import type { Dtos, IndividualContactId, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../account.keys";

export const useAdminRunIndividualCreditReport = (accountId: SuretyAccountId) => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async (individualId: IndividualContactId) =>
			post<Dtos.CreditReport.Individual.Admin.Response>(
				`/v2/admin/surety/accounts/${accountId}/individuals/${individualId}/credit-report`,
			),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
		},
	});

	return {
		runIndividualCreditReport: mutation.mutate,
		runIndividualCreditReportPending: mutation.isPending,
		runIndividualCreditReportError: mutation.error,
		failedIndividualId: mutation.isError ? mutation.variables : undefined,
		resetRunIndividualCreditReport: mutation.reset,
	};
};
